import {ErrorLocationType, ErrorType} from "@/utilities/enums/Enums";
import {GeneralOldResponse} from "@/models/api/old/responses";
import {useGlobalStore} from "@/stores/GlobalStore";
import router from "@/router";
import {isDev} from "@/AppConfig";
import {currentRouteIsExternal} from "@/utilities/helpers/RoutingHelper";
import GeneralResponse from "@/models/api/GeneralResponse";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import {useErrorStore} from "@/stores/ErrorStore";
import type {AxiosError} from 'axios'
import {i18n} from "@/utilities/i18n/config";


class ErrorHandler {
    private t = i18n.global.t

    public async handleResponse(response: GeneralResponse, errorLocation: ErrorLocationType) {
        const errorType = NullOrUndefinedHelper(response.requestId) ? ErrorType.error : ErrorType.warning

        // handle access issues
        const isAccessIssue = response.data && (response.data as AxiosError).response?.status && (response.data as AxiosError).response?.status === 401
        if (isAccessIssue && !isDev) {
            (useGlobalStore()).redirectAfterLogin = window.location.pathname + window.location.search;
            await router.replace("/login");
        }

        const errorStore = useErrorStore()
        errorType === ErrorType.warning
            ? errorStore.showError(
                this.t('general.error.api.warning', {method: this.t(response.context ?? '')}),
                errorType,
                errorLocation
            )
            : errorStore.showError(
                this.t('general.error.api.error', {
                    method: this.t(response.context ?? ''),
                    status: response.data ? (response.data as AxiosError).response?.status : 400
                }),
                errorType,
                errorLocation
            )
    }

    public async handleOldError(error:GeneralOldResponse, errorLocation:ErrorLocationType){
        const errorType = error.statusCode === 400
            ? ErrorType.warning
            : ErrorType.error;

        const notify = await this.reactoToStatusCode(error.statusCode as number);
        if (notify) {
            errorType === ErrorType.warning
                ? this.notifyFailedCommunication(errorType, this.t("general.error.api.warning", {method: this.t(error.serviceErrorCode ?? error.method ?? "")}), errorLocation)
                : this.notifyFailedCommunication(errorType, this.t("general.error.api.error", {method: this.t(error.serviceErrorCode ?? error.method ?? ""), status:error.statusCode}), errorLocation)
        }
    }

    public async showLocalError(text:string, errorLocation:ErrorLocationType){
        this.notifyFailedCommunication(ErrorType.warning, text, errorLocation);
    }


    /*  PRIVATE  */


    private notifyFailedCommunication(type:ErrorType, text:string, errorLocation:ErrorLocationType) {
        const errorStore = useErrorStore()

        errorStore.showError(text, type, errorLocation);
    }


    /*
        handles special status codes and what to do when encountering them
        returns if the calling method needs to notify the user
    */
    private async reactoToStatusCode(status:number):Promise<boolean> {
        switch (status) {
            case 401:{
                if(currentRouteIsExternal()){
                    this.notifyFailedCommunication(ErrorType.error, this.t('general.noValidToken'), ErrorLocationType.guest)
                    return false;
                }

                this.notifyFailedCommunication(ErrorType.error, this.t('general.noValidToken'), ErrorLocationType.login);
                if(!isDev) {
                    (useGlobalStore()).redirectAfterLogin = window.location.pathname + window.location.search;
                    await router.replace("/login");
                }

                return false;
            }

            default:{
                return true;
            }
        }
    }
}

export default new ErrorHandler();
